import React, { Component } from 'react';
import StartLayout from './StartLayout';
import Start from '../components/Start';
import '../css/style.css';
import '../components/Home.css';
import AuthenticationService from '../backend/AuthenticationService';
import DemoLoginLayout from './DemoLoginLayout';

class HomeLayout extends Component {

    render(){
        if (!AuthenticationService.isUserInDemoRole()) {
            return <DemoLoginLayout />
        }
        return (
            <StartLayout>
                <Start />
            </StartLayout>              
        );
    }

}

export default HomeLayout;